import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["star", "input"]

  connect() {
    this.updateDisplay()
  }

  select(event) {
    this.updateDisplay()
  }

  updateDisplay() {
    const checked = this.inputTargets.find(input => input.checked)
    const selectedValue = checked ? parseInt(checked.value) : 0

    this.starTargets.forEach(star => {
      const value = parseInt(star.dataset.value)
      if (value <= selectedValue) {
        star.classList.remove("text-slate-200")
        star.classList.add("text-amber-400")
      } else {
        star.classList.remove("text-amber-400")
        star.classList.add("text-slate-200")
      }
    })
  }
}
